export default __webpack_public_path__ + "static/Seeing-Far-7a61e9b96c48e7604d642cbf997b033a.png";